<template>
  <div :class="`column col-${column.length}`" v-for="(col, i) in column" :key="i">
    <template v-for="(block, j) in col.blocks" :key="j">
      <LayoutBlock v-if="typeof block === 'object'" :block="block" :context="context" />
    </template>
  </div>
</template>

<script setup>
defineProps({
  column:  { type: Object, required: true, default: () => ({}) },
  context: { type: Object, required: false, default: () => ({}) },
})
</script>

<style scoped>
div { flex: 1; min-width: 0; }
</style>
